import { AppGroupType } from '@wix/app-market-services';
import type { AppGroupSection, Services } from '@wix/app-market-services';
import type { QueryAppsResponse } from '../../components/apps-section';

const emptyAppGroup = (): AppGroupSection => ({
  type: AppGroupType.COLLECTION,
  tagSlug: 'developer-page',
  apps: [],
  title: '',
  totalAppsCount: 0,
  appIds: [],
});

export async function queryDeveloperApps({
  appIds,
  services,
}: {
  appIds: string[];
  services: Services;
}): Promise<QueryAppsResponse> {
  if (appIds.length === 0) {
    return {
      appGroup: emptyAppGroup(),
      paging: { total: 0, hasNext: false },
    };
  }

  try {
    const appsData = await services.getAppsByAppIds({
      appIds,
      status: 'PUBLISHED',
    });
    const appsById = new Map(appsData.toJSON().map((app) => [app.id, app]));
    const apps = appIds
      .map((id) => appsById.get(id))
      .filter((app): app is NonNullable<typeof app> => Boolean(app));

    return {
      appGroup: {
        ...emptyAppGroup(),
        apps: apps as AppGroupSection['apps'],
        totalAppsCount: apps.length,
      },
      paging: {
        total: 0,
        hasNext: false,
      },
    };
  } catch {
    // A transient apps-fetch failure shouldn't blank the whole developer page
    // (header/top section render independently) - degrade to an empty grid instead.
    return {
      appGroup: emptyAppGroup(),
      paging: { total: 0, hasNext: false },
    };
  }
}
